module.exports = __webpack_public_path__ + "img/ring_r_x_o_null@3x.3f91b836.png";